// extracted by mini-css-extract-plugin
export var alert = "cM_hH";
export var error = "cM_hJ";
export var text = "cM_dh";